import {NgModule} from '@angular/core';
import {ViewComponent} from './3DView/view.component';
import {PictureComponent} from './3DView/Picture/picture.component';
import {CanvasRendererComponent} from './3DView/Scene/canvas-renderer.component';
import {BrowserModule, HAMMER_GESTURE_CONFIG, HammerModule} from '@angular/platform-browser';

import {WebWorkerService} from 'ngx-web-worker';
import {UpdateService} from './Utils/update.service';
import {MatProgressBarModule} from '@angular/material/progress-bar';
import {MatIconModule} from '@angular/material/icon';
import {MatDialogModule} from '@angular/material/dialog';
import {MatButtonModule} from '@angular/material/button';
import {PictureLandmarkComponent} from './3DView/Picture/PictureLandmark/picture-landmark.component';
import {CustomHammerConfig} from './customHammerConfig';
import {MatButtonToggleModule} from '@angular/material/button-toggle';
import {MatCardModule} from '@angular/material/card';
import {MatInputModule} from '@angular/material/input';
import {MatRadioModule} from '@angular/material/radio';
import {FormsModule} from '@angular/forms';


@NgModule({
    declarations: [
        ViewComponent,
        PictureComponent,
        CanvasRendererComponent,
        PictureLandmarkComponent
    ],
    imports: [
        BrowserModule,
        MatProgressBarModule,
        MatIconModule,
        MatDialogModule,
        MatButtonModule,
        MatButtonToggleModule,
        HammerModule,
        MatCardModule,
        MatInputModule,
        MatButtonModule,
        MatIconModule,
        MatRadioModule,
        FormsModule
    ],
    providers: [
        UpdateService,
        {
            provide: HAMMER_GESTURE_CONFIG,
            useClass: CustomHammerConfig
        },
        WebWorkerService],
    entryComponents: [],
    exports: [ViewComponent, PictureComponent, PictureLandmarkComponent]
})
export class Surface3dModule {
}
